import { List, Record } from 'immutable'
import { INotification, Notification } from './Notification'

export interface INotificationsContextState {
  readonly error?: string
  readonly isLoading: boolean
  readonly isOpen: boolean
  readonly isReadingAll: boolean
  readonly items: List<INotification>
  readonly unseenCount: number
}

const NotificationsContextStateRecord = Record({
  error: undefined,
  isLoading: false,
  isOpen: false,
  isReadingAll: false,
  items: List<Notification>(),
  unseenCount: 0,
})

export class NotificationsContextState extends NotificationsContextStateRecord
  implements INotificationsContextState {
  public static fromJS(initialState?: Partial<INotificationsContextState>) {
    if (!initialState) {
      return new NotificationsContextState()
    }

    const { items, ...rest } = initialState

    return new NotificationsContextState({
      items: items
        ? List(items.map((i) => Notification.fromJS(i)))
        : List<Notification>(),
      ...rest,
    })
  }

  public readonly error?: string
  public readonly isLoading: boolean
  public readonly isOpen: boolean
  public readonly isReadingAll: boolean
  public readonly items: List<Notification>
  public readonly unseenCount: number

  constructor(props?: Partial<NotificationsContextState>) {
    props ? super(props) : super()
  }
}
